// Customize the Algolia Autocomplete
// https://www.algolia.com/doc/integration/shopify/building-search-ui/frontend-custom-events/
(function () {
  // Wait for Algolia to load the search client

  const MAX_RETRIES = 50; // ~50 × 50ms = 2.5 secs
  let attempts = 0;

  const wait = setInterval(() => {
    attempts++;

    const client = window.algoliaShopify?.searchClient;

    if (attempts >= MAX_RETRIES) {
      clearInterval(wait);
      console.warn("Algolia client not found after maximum attempts");
      return;
    }

    if (!client) {
      return;
    }

    clearInterval(wait);

    const originalSearch = client.search.bind(client);
    let lastNoResultsQuery = null;
    let debounceTimer = null;
    const DEBOUNCE_DELAY = 250; // ms

    client.search = function (requests) {
      const query = requests[0].query || "";

      // Block queries that are too short
      const hasShortQuery = query.length < 3;

      // True if the query continues the one without results found earlier
      const isContinuation =
        lastNoResultsQuery && query.startsWith(lastNoResultsQuery);

      // True if there is a space + a letter (e.g., "xxx a")
      const startsNewWord = /\s+\S/.test(query);

      // Block: continue the same word without starting a new word
      const shouldBlockNoResults = isContinuation && !startsNewWord;

      if (hasShortQuery || shouldBlockNoResults) {
        // returns a Promise with empty results
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
          })),
        });
      }

      // DEBOUNCE
      return new Promise((resolve) => {
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
          originalSearch(requests).then((res) => {
            // Check all sources
            const allNoResults = res.results.every((r) => r.nbHits === 0);

            if (allNoResults) {
              lastNoResultsQuery = query;
            } else {
              lastNoResultsQuery = null;
            }

            resolve(res);
          });
        }, DEBOUNCE_DELAY);
      });
    };

    console.log("Algolia search patched with debounce + no-results blocking");
  }, 50);
})();

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteAsyncFunction",
    async function () {
      algoliaShopify.config.index_suffix = (function () {
        return "_italy_ia";
      })();
      // The override below does not work. Contact Algolia support
      // It is currently configured in the Algolia Shopify app
      /*
      algoliaShopify.config.query_suggestions_index_name = (function () {
        return "shopify_prod_products_italy_ia_query_suggestions";
      })();
      algoliaShopify.config.query_suggestions_index_name =
        "shopify_prod_products_italy_ia_query_suggestions";
      */
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      const algolia = window.algoliaShopify;
      const config = algolia.config;
      const vendorsPlugin = {
        getSources({ query }) {
          return [
            {
              sourceId: "vendors",
              getItems() {
                return algolia.externals.getAlgoliaResults({
                  searchClient: algolia.searchClient,
                  queries: [
                    {
                      indexName: `${config.index_prefix}collections${config.index_suffix}`,
                      query,
                      params: {
                        hitsPerPage:
                          config.collections_autocomplete_hits_per_page,
                        clickAnalytics: config.analytics_enabled,
                        filters:
                          "template_suffix:vendor AND NOT meta.seo.hidden:1",
                      },
                    },
                  ],
                });
              },
              templates: {
                header({ html }) {
                  return html` <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">Cantine</span>
                    <div class="aa-SourceHeaderLine"></div>
                  </div>`;
                },
                item({ item, html, components }) {
                  const itemLink = `${window.Shopify.routes.root}collections/${item.handle}`;

                  return html` <a
                    href=${itemLink}
                    class="aa-ItemLink tw:h-full"
                  >
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">${item.title}</div>
                        </div>
                      </div>
                    </div>
                  </a>`;
                },
              },
            },
          ];
        },
      };

      const selectionsPlugin = {
        getSources({ query }) {
          return [
            {
              sourceId: "selections",
              getItems() {
                return algolia.externals.getAlgoliaResults({
                  searchClient: algolia.searchClient,
                  queries: [
                    {
                      indexName: `${config.index_prefix}collections${config.index_suffix}`,
                      query,
                      params: {
                        hitsPerPage:
                          config.collections_autocomplete_hits_per_page,
                        clickAnalytics: config.analytics_enabled,
                        filters:
                          "(NOT template_suffix:vendor) AND (NOT template_suffix:tfs-plp) AND NOT meta.seo.hidden:1",
                      },
                    },
                  ],
                });
              },
              templates: {
                header({ html }) {
                  return html` <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">Selezioni</span>
                    <div class="aa-SourceHeaderLine"></div>
                  </div>`;
                },
                item({ item, html, components }) {
                  const itemLink = `${window.Shopify.routes.root}collections/${item.handle}`;

                  return html` <a
                    href=${itemLink}
                    class="aa-ItemLink tw:h-full"
                  >
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">${item.title}</div>
                        </div>
                      </div>
                    </div>
                  </a>`;
                },
              },
            },
          ];
        },
      };

      options.plugins.push(vendorsPlugin);
      options.plugins.push(selectionsPlugin);
      options.placeholder = "Cerca";
      options.translations = {
        clearButtonTitle: "Annulla",
        detachedCancelButtonText: "Annulla",
        submitButtonTitle: "Cerca",
      };
      options.debug = false;
      return options;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteRedirectUrlOptions",
    function (options) {
      return {
        templates: {
          item({ html, state }) {
            return html`<a>${state.query}</a>`;
          },
        },
      };
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable tw:text-sm">
          ${displaySuggestions &&
          html`
            <div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle">Suggerimenti</span>
              <div class="aa-SourceHeaderLine"></div>
            </div>
            ${elements.querySuggestionsPlugin}
          `}
          ${elements.vendors} ${elements.selections} ${elements.articles}
          ${elements.pages} ${elements.redirectUrlPlugin} ${elements.products}
        </div>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainProductsTemplate",
    function (_defaultTemplate, templateOptions, elements) {
      const { html } = templateOptions;
      return html` <div>${elements.products}</div> `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html``;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteHeaderTemplate",
    function (_defaultTemplate, templateOptions, resource) {
      const { html, state } = templateOptions;
      return html`
        <div class="aa-SourceHeader">
          <span class="aa-SourceHeaderTitle">
            ${resource != "Products"
              ? algoliaShopify.translation_helpers.render_title(
                  resource,
                  state.query,
                )
              : "Prodotti trovati per " + state.query}
          </span>
          <div class="aa-SourceHeaderLine"></div>
        </div>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteFooterTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html`
        <div>
          <a href="${window.Shopify.routes.root}search?q=${state.query}">
            ${algoliaShopify.translations.allProducts}
            (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
          </a>
        </div>
      `;
    },
  );
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution,
    ) {
      const { html, item, components } = templateOptions;

      const renderImageData = algoliaShopify.helpers.renderImage(item, 50);

      const itemImage = html`
        <img
          src="${renderImageData.src}"
          srcset="${renderImageData.srcset}"
          sizes="${renderImageData.sizes}"
          alt="${item.title}"
        />
      `;

      const emptyImage = html`
        <div class="tw:h-12.5 tw:w-12.5 tw:bg-gray-50"></div>
      `;

      const variantMinPrice = item.variants_min_price;
      const variantCompareAtPriceMin = item.variants_compare_at_price_min;
      const variantCurrency = item.currency;

      const omnibusRaw = item.meta?.omnibus?.omnibus_prices?.it;
      const omnibusPrice =
        variantCompareAtPriceMin > 0 && omnibusRaw
          ? parseInt(omnibusRaw, 10) / 100
          : variantCompareAtPriceMin;

      const displayPrice = algoliaShopify.helpers.displayPrice(item, distinct);

      const strikedPrice = algoliaShopify.helpers.displayStrikedPrice(
        variantMinPrice,
        omnibusPrice,
        variantCurrency,
      );

      const strikedTemplate = strikedPrice
        ? html`<span class="tw:mr-2 tw:text-gray-500 tw:line-through"
            >${strikedPrice}</span
          >`
        : "";

      return html`
        <a href="${itemLink}" onClick="${() => trackSearchAttribution(item)}">
          <div
            class="tw:grid tw:w-full tw:grid-cols-[auto_1fr_auto] tw:items-center tw:gap-4"
          >
            <div class="tw:shrink-0">
              ${item.product_image ? itemImage : emptyImage}
            </div>
            <div
              class="tw:grow tw:overflow-hidden tw:text-ellipsis tw:whitespace-normal"
            >
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span>
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
            <div
              class="tw:shrink-0 tw:whitespace-nowrap tw:font-bold tw:text-black"
            >
              ${strikedTemplate} ${displayPrice}
            </div>
          </div>
        </a>
      `;
    },
  );
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteArticlesTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      const { item, html, components } = templateOptions;
      return html`
        <a href="${itemLink}">
          <div>
            <div>
              <img
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>
            <div>
              <div>
                ${components.Highlight({ hit: item, attribute: "title" })}
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteCollectionsTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;
      return html`
        <a href="${itemLink}">
          <div>
            <div>
              <img
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>
            <div>
              <div>
                ${components.Highlight({ hit: item, attribute: "title" })}
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompletePagesTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;
      return html`
        <a href="${itemLink}">
          <div>
            <div>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div>
              <div>
                ${components.Highlight({ hit: item, attribute: "title" })}
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );
});
